import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';

import { PAGES } from '_constants';
import { licensePropType } from '_utils/licenses';
import {
  getACLicenseExpiresOnLabel,
  getACLicenseTypeLabel,
  getACLicensePoolLabel,
  getACLicensePoolId
} from '_utils/activationCodes';

import LineItem from '_views/lineItem'
import UserInfo from '_views/userInfo'

const ActivationCodeInfo = ({ license, setNavigation }) => {

  const onGoToUser = () => setNavigation({ pageName: PAGES.USERS, ids: [license.activated_by._id] });

  return (
    <Grid>
      <Grid.Row>
        <Grid.Column width={10}>
          <LineItem label='Activation Code' text={ license.activated_info.ac_id || '' } />
          <LineItem label='AC Type' text={ getACLicenseTypeLabel(license) } />
          <LineItem label='Expires' text={ getACLicenseExpiresOnLabel(license) } />
          <LineItem label='License count' text={ license.activated_info.license_count || 1 } />
          <LineItem label='Description' text={ license.description || '' } />
          <LineItem label='License Pool' text={ getACLicensePoolLabel(license) } />
          <LineItem label='License Pool ID' text={ getACLicensePoolId(license) } />
        </Grid.Column>
        <Grid.Column width={6}>
          <div>
            <b>Activated by:</b>
          </div>
          <UserInfo onClick={ onGoToUser } user={ license.activated_by } />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
}

ActivationCodeInfo.propTypes = {
  license: licensePropType,
  setNavigation: PropTypes.func.isRequired
}

export default ActivationCodeInfo;



// WEBPACK FOOTER //
// ./webAdmin/views/license/activationCode.js